/**
 * Clever Cloud fork
 * https://github.com/CleverCloud/clever-components/blob/master/src/mixins/with-resize-observer.js
 * @param ParentClass
 * @returns ResizableLitElement
 */
export const withResizeObserver = (ParentClass) => {
    class ClassWithResizeObserver extends ParentClass {
        constructor() {
            super(...arguments);
            this._rafId = null;
            this._lastWidth = null;
        }
        _onResize({ width }) {
            if (this._lastWidth === width) {
                return;
            }
            this._lastWidth = width;
            this._width = width;
            if (this.onResize != null) {
                this.onResize({ width });
            }
            if (this.breakpoints != null) {
                this.breakpoints.width.forEach(breakpoint => {
                    const gteAttr = 'w-gte-' + breakpoint;
                    breakpoint <= width
                        ? this.setAttribute(gteAttr, '')
                        : this.removeAttribute(gteAttr);
                    const ltAttr = 'w-lt-' + breakpoint;
                    width < breakpoint
                        ? this.setAttribute(ltAttr, '')
                        : this.removeAttribute(ltAttr);
                });
            }
            if (this.isConnected) {
                this.requestUpdate();
            }
        }
        connectedCallback() {
            if (super.connectedCallback != null) {
                super.connectedCallback();
            }
            if (window.ResizeObserver == null) {
                return;
            }
            // Trigger an initial measurement
            const { width } = this.getBoundingClientRect();
            this._onResize({ width });
            const ro = new window.ResizeObserver(() => {
                if (this._rafId != null) {
                    cancelAnimationFrame(this._rafId);
                }
                this._rafId = requestAnimationFrame(() => {
                    // NOTE: We could use entries[0].borderBoxSize.inlineSize but not supported in Chrome, Safari or polyfill
                    const { width } = this.getBoundingClientRect();
                    this._onResize({ width });
                    this._rafId = null;
                });
            });
            ro.observe(this);
            this._unobserveResize = () => ro.unobserve(this);
        }
        disconnectedCallback() {
            if (super.connectedCallback != null) {
                super.disconnectedCallback();
            }
            if (this._unobserveResize) {
                this._unobserveResize();
            }
            if (this._rafId != null) {
                cancelAnimationFrame(this._rafId);
                this._rafId = null;
            }
        }
    }
    return ClassWithResizeObserver;
};
//# sourceMappingURL=with-resize-observer.js.map